import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './VerifyEmailPage.scss';
import { UserManagerApi } from '../../api/UserManagerApi';
import { t } from 'i18next';

const VerifyEmailPage = (): JSX.Element => {
    const { logout, user, getAccessTokenSilently } = useAuth0();

    const backToLanding = () => {
        logout({ logoutParams: { returnTo: window.location.origin } });
    };

    const resendVerificationEmail = async () => {
        const successCallback = () => {
            console.log('Sent');
        };

        const failureCallback = (error: string) => {
            console.log('Error when sending email: ', error);
        };

        const token = await getAccessTokenSilently();

        new UserManagerApi().sendUserVerificationEmail(
            user.sub,
            token,
            successCallback,
            failureCallback
        );
    };

    return (
        <div className='verify-container'>
            <div className='verify-info-container'>
                <div className='row' style={{ justifyContent: 'center' }}>
                    <div className='col-xs-12'>
                        <FontAwesomeIcon
                            icon={faEnvelope}
                            size='4x'
                            color='darkgray'
                        />
                    </div>
                </div>
                <div className='row' style={{ justifyContent: 'center' }}>
                    <div className='col-xs-12'>
                        <p className='verify-exclaimation'>
                            {t('email_verification_message')}
                            <span></span>
                        </p>
                    </div>
                </div>
                <div
                    className='row'
                    style={{
                        justifyContent: 'space-around',
                        marginTop: '1em'
                    }}>
                    <div
                        className='col-md-6 col-sm-12'
                        style={{
                            display: 'flex',
                            justifyContent: 'space-evenly'
                        }}>
                        <button
                            className='btn btn-primary'
                            onClick={resendVerificationEmail}>
                            {t('resend_verification')}
                        </button>
                        <button
                            className='btn btn-secondary'
                            onClick={backToLanding}>
                            {t('go_to_home')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerifyEmailPage;
